export default "__VITE_ASSET__DlDpHykX__"